<template>
    <div class="form-sub-section notes-section">
        <div class="d-flex justify-content-between align-items-center">
            <h3 class="main-text-large">{{ $t("res_Label_Transfers") }}</h3>
            <v-spacer></v-spacer>
            <div class="position-relative d-inline ml-2 mr-2">
                <button class="view-all-btn d-flex align-items-center"  @click="exportTransfersToPdf()" v-tooltip="$t('res_Export_To_Pdf')">
                <v-icon class="light">mdi-file-pdf-box</v-icon></button>
            </div>
            <v-btn @click="collapseTransfers = !collapseTransfers"
                   class="dgs-new-button" style="width: 40px; min-width: unset !important">
                <span v-if="collapseTransfers" class="arrow-down"></span>
                <span v-else class="arrow-up"></span>
            </v-btn>  
        </div>
        <v-divider v-if="!collapseTransfers && transfers.length > 0"></v-divider>
        <div v-bind:class="{ 'with-view-all': transfersFullList.length > defaultNumberOfTransferToDisplay }"  :style="{ display: collapseTransfers ? 'none':'block' }">
            <v-list>
                <v-list-item class="text-hover-list" v-for="(item, i) in transfers" :key="i">
                    <v-list-item-content
                        v-tooltip="item.instruction == '' ? '' : ($t('res_Label_Notes') + ' : ' + item.instruction)">
                        <v-list-item-title>
                            <div class="text-wrap w-75">
                                <span><strong>{{ $t("res_Label_FromUser") }}: </strong>{{ item.fromUserFullName }} -
                                    {{ item.fromStructureName }}</span>
                            </div>
                            <div class="text-wrap w-75">
                                <span><strong>{{ $t("res_Label_ToUser") }}: </strong>{{ item.toUserFullName }} -
                                    {{ item.toStructureName }}</span>
                            </div>
                            <div class="text-wrap w-75">
                                <span><strong>{{ $t("res_Label_ForwardDate") }}:
                                    </strong>{{ constants.showDateWithTime? utils.formatDateTimeWithTime(item.createdDate) : utils.formatDateTime(item.createdDate)}}</span>
                            </div>
                            <div class="text-wrap w-75">
                                <span><strong>{{ $t("res_Label_Action") }}: </strong>{{ item.purpose }}</span>
                            </div>
                            <div class="text-wrap w-75">
                                <span><strong>{{ $t("res_Label_Instruction") }}: </strong>{{ language == 'en' ? item.instruction : (item.instructionAr == null || item.instructionAr === '' ? item.instruction : item.instructionAr) }}</span>
                            </div>
                        </v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </v-list>
            <v-divider class="view-all-divider"
                v-if="transfersFullList.length > defaultNumberOfTransferToDisplay"></v-divider>
            <div class="view-all-wrapper d-flex justify-content-center align-content-center"
                v-if="transfersFullList.length > defaultNumberOfTransferToDisplay">
                <button class="view-all-btn d-flex align-items-center" @click="viewAllNotes()"
                    v-if="numberOfTransferToDisplay != 1000">
                    {{ $t("res_ButtonText_ViewAll") }} <v-icon class="light">mdi-chevron-down</v-icon>
                </button>
                <button class="view-all-btn d-flex align-items-center" @click="viewAllNotes()"
                    v-if="numberOfTransferToDisplay == 1000">
                    {{ $t("res_ButtonText_ShowLess") }} <v-icon class="light">mdi-chevron-up</v-icon>
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import constants from '@/assets/js/constants';
import * as utils from '@/assets/js/common.js';



export default {
    name: 'TransferList',
    props: {
        documentId: { type: [String, Number], default: '0' },
        delegationId: { type: Number, default: 0 },
    },
    data: () => (
        {
            language: 'en',
            transfers: [],
            transfersFullList: [],
            defaultNumberOfTransferToDisplay: 2,
            numberOfTransferToDisplay: 2,
            utils: utils,
            loginUser:0,
            loginUserId:0,
            toUserId:0,
            collapseTransfers : true,
            constants: constants,
        }
    ),
    watch:
    {
        documentId(newVal, oldVal) {
            if (oldVal != newVal && newVal > 0) {
                this.getTransfers();
            }
        }
    },
    methods:
    {
        getTransferNotesCount(count) {
            this.$emit("getTransferNotesCount", count);
        },
        exportTransfersToPdf() {
            if (this.documentId == 0) return
            var extension = this.exportType == 1 ? '.xlsx' : '.pdf';
            axios({
                    url: constants.baseApiUrl + 'Transfer/GetTransfersListByDocumentId?documentId=' + this.documentId + '&extractToPdf=1' + '&delegationId=' + this.delegationId,
                    method: 'GET',
                    responseType: 'blob',
                })
                    .then((res) => {
                        var blob = new Blob([res.data], { type: "application/octetstream" });
                        const link = window.URL.createObjectURL(blob);
                        const a = document.createElement("a");
                        a.setAttribute("download", "ExportedData" + `${extension}`);
                        a.setAttribute("href", link);
                        document.body.appendChild(a);
                        a.click();
                        document.body.removeChild(a);
                    })
                    .catch((err) => window.hideLoading())
                    .finally(() => window.hideLoading())
        },
        viewAllNotes() {
            if (this.numberOfTransferToDisplay == 1000) {
                this.numberOfTransferToDisplay = this.defaultNumberOfTransferToDisplay
                this.transfers = this.transfersFullList.slice(0, this.defaultNumberOfTransferToDisplay)
            }
            else {
                this.numberOfTransferToDisplay = 1000
                this.transfers = this.transfersFullList
            }
        },
        getTransfers() {
            if (this.documentId == 0) return
            this.transfers = []
            this.transfersFullList = []
            this.numberOfTransferToDisplay = this.defaultNumberOfTransferToDisplay

            axios.get(constants.baseApiUrl + 'Transfer/GetTransfersListByDocumentId?documentId=' + this.documentId + '&delegationId=' + this.delegationId)
                .then(response => {
                    let instructionCounter = 0;
                    response.data.forEach(element => {
                        var transferElement = {
                            fromUserFullName: element.fromUserFullName, toUserFullName: element.toUserFullName,
                            createdDate: element.createdDate, instruction: element.instruction,instructionAr: element.instructionAr, purpose: element.purpose,
                            toStructureName: element.toStructureName, fromStructureName: element.fromStructureName,
                            //fromCompanyName: element.fromCompanyName, toCompanyName: element.toCompanyName,
                            toUserId:element.toUserId
                        }
                        if (element?.instruction || element?.instructionAr) {
                            instructionCounter += 1;
                        }
                        if (this.transfers.length < this.defaultNumberOfTransferToDisplay) {
                            this.transfers.push(transferElement)
                        }
                        this.transfersFullList.push(transferElement)
                    });

                    this.getTransferNotesCount(instructionCounter);
                })
                .catch(error => this.handleError(error))
        }
    },
    mounted() {
        this.language = localStorage.getItem('lang');
        this.getTransfers()
        this.loginUser = sessionStorage.getItem("user");
        const userObject = JSON.parse(this.loginUser);
        const id = userObject.profile.Id;
        this.loginUserId = id;
    }
}
</script>

<style></style>